export default {
  sections: {
    settings: 'Impostazioni',
  },
  status_switch: {
    label: 'Programma fedeltà',
    on: 'Attivo',
    off: 'Disattivo',
    description: 'I clienti guadagnano cashback su ogni ordine e possono riscattarlo al checkout.',
    description_missing: 'Salva le impostazioni qui sotto per avviare il tuo programma fedeltà.',
  },
  alerts: {
    off: 'Il programma fedeltà è disattivato. I clienti non guadagnano cashback sui nuovi ordini, non possono riscattare i punti e non vedono il programma nel tuo negozio. I punti già raccolti vengono mantenuti e scadono normalmente.',
    expired: 'Il tuo programma fedeltà è terminato. Attivalo per riavviarlo senza data di fine.',
  },
  form: {
    title: {
      label: 'Titolo',
    },
    percentage: {
      label: 'Percentuale cashback',
      validation: {
        required: 'La percentuale cashback è obbligatoria',
        min: 'Il valore minimo della percentuale cashback è {{value}}%',
        max: 'Il valore massimo della percentuale cashback è {{value}}%',
      },
    },
    point_lifetime: {
      label: 'Quanti giorni vuoi dare ai tuoi clienti per utilizzare i punti?',
      validation: {
        min: 'Minimo {{value}} giorni per la scadenza dei punti',
      },
    },
    min_spending_limit: {
      label: 'Limite di spesa minimo per il cashback',
      validation: {
        required: 'Il limite di spesa minimo è obbligatorio',
        gt_zero: 'Il limite di spesa minimo deve essere maggiore di 0',
        lt_max_spending_limit: 'Il limite di spesa minimo deve essere inferiore al limite di spesa massimo',
      },
    },
    max_spending_limit: {
      label: 'Limite di spesa massimo per il cashback',
      validation: {
        required: 'Il limite di spesa massimo è obbligatorio',
        gt_min_spending_limit: 'Il limite di spesa massimo deve essere superiore al limite di spesa minimo',
      },
    },
    has_welcome_bonus: {
      label: 'Bonus di benvenuto',
      description: 'Offri ai nuovi clienti un bonus cashback di iscrizione',
    },
    welcome_bonus: {
      label: 'Valore del bonus di benvenuto',
    },
    has_end_date: {
      label: 'Durata',
      options: {
        false: 'Illimitata',
        true: 'Con data di scadenza specifica',
      },
    },
    end_date: {
      label: 'Data di scadenza',
    },
    has_mobile_app_signup_bonus: {
      label: 'Bonus iscrizione App mobile',
      description: "Premia gli utenti che accedono tramite l'app mobile per la prima volta",
    },
    mobile_app_signup_bonus: {
      label: 'Importo bonus',
    },
  },
  tags: {
    inactive: 'Non attivo',
    active: 'Attivo',
    expired: 'Scaduto',
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    changes_got_saved: 'Modifiche salvate',
    failed_to_save_changes: 'Salvataggio modifiche non riuscito',
    turned_on: 'Programma fedeltà attivato',
    turned_off: 'Programma fedeltà disattivato',
  },
};
